<template>
  <div class="detail">
    <!-- 顶部 -->
    <detailHeader />
    <div class="orderDetail">
      <div class="search">
        <div class="item">
          <el-input v-model="order_sn" placeholder="请输入订单号" clearable></el-input>
        </div>
        <el-button type="primary" @click="orderDetails">查询</el-button>
        <div class="uploadFile">
          <el-upload class="avatar-uploader" :action="baseURL + '/admin/bulk/order/importBulkExcelFile'"
            :show-file-list="false" :on-success="handleFileSuccess" :data="{ order_sn: order_sn }" :headers="{
              AdminToken: 'Bearer ' + token
            }">
            <el-button type="primary" class="primary">标签文件上传</el-button>
          </el-upload>
        </div>
      </div>
      <div class="table">
        <ol>
          <li class="flex05" @click="selectAll">
            <el-checkbox v-model="checkedAll" @change="selectAll"></el-checkbox>
          </li>
          <li class="flex05">番号</li>
          <li>图片</li>
          <li>大货数量</li>
          <li>大货单价</li>
          <li>大货单个运费</li>
          <li>单个商品尺寸.cm</li>
          <li>单个重量.kg</li>
          <li class="flex15">大货option</li>
          <li>实物图</li>
          <li>录入尺寸.cm</li>
          <li>体积重量（kg）</li>
          <li>录入重量.g</li>

          <li>操作</li>

        </ol>
        <ul v-for="(item, index) in detail.order_detail" :key="index">
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="handleSelectChange"></el-checkbox>
          </li>
          <li class="flex05">{{ item.sorting }}</li>
          <li>
            <el-image :src="item.pic" fit="fill" :preview-src-list="[item.pic]"
              style="width: 80px; height: 80px; margin-right: 10px;" />
            <div class="icon">
              <p style="margin-bottom: 20px;">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  <img src="https://img.alicdn.com/imgextra/i1/O1CN01FLiUvb1K4szSnB9fw_!!6000000001111-2-tps-176-68.png"
                    style="width: 30px;"></img>
                </a>
              </p>
              <a :href="`https://www.rakumart.com/ProductDetails?goods_id=${item.goods_id}&fromPlatform=${item.from_platform}`"
                target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/img/logo2.png" style="width: 30px;"></img>
              </a>
            </div>
          </li>
          <li>
            <el-input v-model="item.bulk_quantity" placeholder="请输入大货数量" clearable
              @blur="bulkOrderSaveDetail(item, 'bulk_quantity', item.bulk_quantity)" type="number"
              @input="allEdit(item, 'bulk_quantity', item.bulk_quantity)"></el-input>
          </li>
          <li>
            <el-input v-model="item.bulk_price" placeholder="请输入大货单价" clearable
              @blur="bulkOrderSaveDetail(item, 'bulk_price', item.bulk_price)" type="number"
              @input="allEdit(item, 'bulk_price', item.bulk_price)"></el-input>
          </li>
          <li>
            <el-input v-model="item.bulk_freight" placeholder="请输入大货运费" clearable
              @blur="bulkOrderSaveDetail(item, 'bulk_freight', item.bulk_freight)" type="number"
              @input="allEdit(item, 'bulk_freight', item.bulk_freight)"></el-input>
          </li>
          <!-- 单个重量.kg -->
          <li>
            <div class="template">
              <div class="row">
                <el-input v-model="item.length" placeholder="请输入长度" clearable
                  @blur="bulkOrderSaveDetail(item, 'volume', item.length)" type="number" size="small"
                  @input="allEdit(item, 'length', item.length)">
                </el-input>
              </div>
              <div class="row">
                <el-input v-model="item.width" placeholder="请输入宽度" clearable
                  @blur="bulkOrderSaveDetail(item, 'volume', item.width)" type="number" size="small"
                  @input="allEdit(item, 'width', item.width)">
                </el-input>
              </div>
              <div class="row">
                <el-input v-model="item.height" placeholder="请输入高度" clearable
                  @blur="bulkOrderSaveDetail(item, 'volume', item.height)" type="number" size="small"
                  @input="allEdit(item, 'height', item.height)">
                </el-input>
              </div>
            </div>
          </li>

          <li>
            <el-input v-model="item.weight" placeholder="请输入重量" clearable
              @blur="bulkOrderSaveDetail(item, 'weight', item.weight)" type="number"
              @input="allEdit(item, 'weight', item.weight)">
            </el-input>
          </li>
          <li class="flex15">
            <div class="attribute services">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row" v-for="(opti, optiIndex) in item.bulk_option" :key="optiIndex"
                    style="margin-bottom: 3px">
                    <p>
                      {{ optiIndex + 1 }}.{{ opti.name }}:
                      <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                    </p>
                  </div>
                </div>
                <div style="height: 100px">
                  <div class="row" v-for="(opti, optiIndex) in item.bulk_option" :key="optiIndex">
                    <p>
                      {{ optiIndex + 1 }}.{{ opti.name }}:
                      <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                    </p>
                  </div>
                </div>
              </el-tooltip>
            </div>
            <div class="edit">
              <i class="el-icon-edit-outline" @click="bulkOptionEdit(item, index)"></i>
            </div>
          </li>
          <!-- 实物图 -->
          <li>
            <div class="tamplate">
              <div class="imgList">
                <div class="item" v-for="(img, imgIndex) in item.order_detail_extend_tj.images" :key="imgIndex">
                  <el-image :src="img" fit="fill" :preview-src-list="[img]" />
                  <i class="el-icon-error" @click="deleteImg(item, index, imgIndex)"></i>
                </div>
              </div>
              <div class="add" @click="i = index">
                <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="httpUpload"
                  :before-upload="beforeAvatarUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </div>

          </li>
          <!-- 录入尺寸 -->
          <li>
            <div class="template" v-if="item.order_detail_extend_tj">
              <div class="row">
                <el-input v-model="item.order_detail_extend_tj.length" placeholder="请输入长度" clearable
                  @blur="setExtend(item, 'setExtendLength', 'length', item.order_detail_extend_tj.length)" type="number"
                  size="small">
                </el-input>
              </div>
              <div class="row">
                <el-input v-model="item.order_detail_extend_tj.width" placeholder="请输入宽度" clearable
                  @blur="setExtend(item, 'setExtendWidth', 'width', item.order_detail_extend_tj.width)" type="number"
                  size="small">
                </el-input>
              </div>
              <div class="row">
                <el-input v-model="item.order_detail_extend_tj.height" placeholder="请输入高度" clearable
                  @blur="setExtend(item, 'setExtendHeight', 'height', item.order_detail_extend_tj.height)" type="number"
                  size="small">
                </el-input>
              </div>
            </div>
          </li>
          <li>
            <div class="template" v-if="item.order_detail_extend_tj">
              {{ ((item.order_detail_extend_tj.length * item.order_detail_extend_tj.width *
                item.order_detail_extend_tj.height) / 6000).toFixed(3) }}
            </div>
          </li>
          <!-- 录入重量 -->
          <li>
            <el-input v-model="item.order_detail_extend_tj.weight" placeholder="请输入重量" clearable
              @blur="setExtend(item, 'setExtendWeight', 'weight', item.order_detail_extend_tj.weight)" type="number"
              size="small">
            </el-input>
          </li>
          <li>
            <div class="template">
              <p class="row">
                <el-button size="small" type="primary" class="primary"
                  @click="printLabel(item, 'pint7x4positive')">7*4正面</el-button>
              </p>
              <p class="row">
                <el-button size="small" type="primary" class="primary"
                  @click="printLabel(item, 'print7x4reverse')">7*4背面</el-button>
              </p>
              <p class="row">
                <el-button size="small" type="primary" class="primary"
                  @click="printLabel(item, 'pint9x95positive')">9*9.5正面</el-button>
              </p>
            </div>

          </li>
        </ul>
      </div>
      <div class="foot" v-if="detail.order_bulk">
        <!--  -->
        <div class="row">
          <el-button type="primary" @click="sameIdGoods">同ID商品</el-button>
          <el-button type="primary" @click="sameStoreGoods">同店铺商品</el-button>
        </div>
        <!--航空便单价(元) -->
        <div class="row">
          <div class="label">
            {{ $t("message.airlineFare") }}(元):
          </div>
          <div class="rmb">
            <el-input v-model="detail.order_bulk.air_price"
              @input="orderBulkPrice('air_price', detail.order_bulk.air_price)"
              @blur="orderBulkUpdatePrice('air_price', detail.order_bulk.air_price)">
              <span slot="append">元</span></el-input>
          </div>
        </div>
        <!--船便的单价(元)： -->
        <div class="row">
          <div class="label">
            {{ $t("message.shipFare") }}(元):
          </div>
          <div class="rmb">
            <el-input v-model="detail.order_bulk.sea_price"
              @input="orderBulkPrice('sea_price', detail.order_bulk.sea_price)"
              @blur="orderBulkUpdatePrice('sea_price', detail.order_bulk.sea_price)">
              <span slot="append">元</span></el-input>
          </div>
        </div>
        <!--船便的单价(元)： -->
        <div class="row">
          <div class="label">
            <!-- 原価計算書 -->
            <el-button type="primary" @click="downloadCostCalculation">原価計算書</el-button>
          </div>

        </div>
      </div>
      <!-- 操作 -->
      <!-- <div class="flex-center">
        <el-button type="primary" @click="orderDetails">保存</el-button>
      </div> -->
    </div>
    <!-- option -->
    <bulk_option ref="bulk_option" :itemDetail="itemDetail" :i="i" />
    <!-- pint7x4positive -->
    <div v-show="false" v-if="isPrint7x4positive">
      <pint7x4positive ref="pint7x4positive" :printData="printData" />
    </div>
    <!-- pint7x4reverse -->
    <div v-show="false" v-if="isPrint7x4reverse">
      <pint7x4reverse ref="pint7x4reverse" :printData="printData" />
    </div>
    <!-- pint90x95 -->
    <div v-show="false" v-if="isPrint90x95">
      <pint90x95 ref="pint90x95" :printData="printData" />
    </div>
  </div>

</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import bulk_option from "../components/bulk_option";
import pint7x4positive from "@/components/Printedsheet/tangji/pint7x4positive.vue"
import pint7x4reverse from "@/components/Printedsheet/tangji/pint7x4reverse.vue"
import pint90x95 from "@/components/Printedsheet/tangji/pint90x95.vue"
import { mapState } from 'vuex'
export default {
  components: {
    detailHeader,
    bulk_option,
    pint7x4positive,
    pint7x4reverse,
    pint90x95
  },
  computed: {
    ...mapState({
      detail: (state) => state.orderDetail.detail,
    }),
  },
  data() {
    return {
      token: localStorage.getItem('japan_access_token'),
      tableData: [],
      order_sn: '',
      itemDetail: {},
      i: 0,
      printData: {},//打印标签数据
      isPrint7x4positive: false,
      isPrint7x4reverse: false,
      isPrint90x95: false,
      checkedAll: false,
    };
  },
  created() {
    this.$store.commit('getDetail', {})
  },
  methods: {

    // 设置扩展信息
    printLabel(item, type) {
      let datas = {
        order_sn: this.order_sn,
        order_detail_id: item.id,
      }
      this.$api.orderApi
        .bulkExcelResult(datas)
        .then((res) => {
          if (res.data == false) return this.$message.error('打印标签数据为空，请上传标签文件')
          let content = res.data[0].content
          content.material = content.material.replace(/\n/g, '<br>')
          content.company = content.company.replace(/\n/g, '<br>')
          content.desc = content.desc.replace(/\n/g, '<br>')
          this.printData = content
          // 打印7x4positive
          if (type == 'pint7x4positive') {
            this.isPrint7x4positive = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint7x4positive);
              this.isPrint7x4positive = false
            }, 500)
          }
          // 打印7x4positive
          if (type == 'print7x4reverse') {
            this.isPrint7x4reverse = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint7x4reverse);
              this.isPrint7x4reverse = false
            }, 500)
          }

          if (type == 'pint9x95positive') {
            this.isPrint90x95 = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint90x95);
              this.isPrint90x95 = false
            }, 500)
          }
        })
    },
    //获取详情
    orderDetails() {
      let datas = {
        order_sn: this.order_sn,
        is_japanfirm: this.$route.query.is_japanfirm,
      }
      this.checkedAll = false
      this.$api.orderApi
        .orderDetails(datas)
        .then((res) => {
          res.data.order_detail.forEach(item => {
            item.checked = false
            item.bulk_option = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_option : []
            item.bulk_quantity = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_quantity : 1000
            item.bulk_freight = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_freight : ''
            item.bulk_price = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_price : ''
            if (!item.volume) {
              item.volume = "0x0x0";
            }
            item.volumes = item.volume.split("x");
            item.length = item.volumes[0];
            item.width = item.volumes[1];
            item.height = item.volumes[2];
            item.weight = item.weight / 1000
            item.order_detail_extend_tj = item.order_detail_extend_tj != null ? item.order_detail_extend_tj : {
              height: '',
              width: '',
              length: '',
              images: [],
              weight: '',
              order_detail_id: item.id,
            }
          })

          res.data.order_bulk = res.data.order_bulk == null ? { air_price: '', sea_price: '' } : res.data.order_bulk
          // 存入vuex
          this.$store.commit('getDetail', res.data)
        });
    },
    //原价计算option
    bulkOptionEdit(item, index) {
      this.itemDetail = JSON.parse(JSON.stringify(item));
      this.i = index;
      this.$refs.bulk_option.dialogVisible = true
    },
    //大货单-保存
    bulkOrderSaveDetail(item, field, value) {
      let datas = {
        order_detail_id: [],
        field,
        value,
      }
      // 处理order_detail_id
      /**
       * 1. 如果item.checked为true，遍历所有order_detail，将所有checked为true的order_detail_id添加到datas.order_detail_id中
       * 2. 如果item.checked为false，将item.id添加到datas.order_detail_id中
       */
      if (item.checked) {
        this.detail.order_detail.forEach((data) => {
          if (data.checked) {
            datas.order_detail_id.push(data.id)
          }
        });
      } else {
        datas.order_detail_id = [item.id]
      }
      if (field == 'volume') {
        datas.value = item.length + 'x' + item.width + 'x' + item.height
      }
      if (field == 'weight') {
        datas.value = item.weight * 1000
      }
      this.$api.orderApi
        .bulkOrderSaveDetail(datas)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success',
            })
          }
        });
    },
    // 订单批量更新价格-计算
    orderBulkPrice(type, price) {
      this.detail.order_bulk[type] = ("" + this.detail.order_bulk[type]) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数

    },
    // 订单批量更新价格
    orderBulkUpdatePrice(type, price) {
      let datas = {
        order_sn: this.order_sn,
        price,
        column: type,
      }
      this.$api.orderApi.orderBulkUpdatePrice(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 下载原価計算書
    downloadCostCalculation() {
      let datas = {
        order_sn: this.order_sn,
        user_id: this.detail.user_id,
        export: 1,
      }
      // 设置responseType为blob以处理文件流
      this.$api.orderApi.bulkOrderPrice(datas, {
        responseType: 'blob'
      }).then(res => {
        // 创建blob对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel' // 根据实际文件类型设置
        });
        // 创建URL
        const url = window.URL.createObjectURL(blob);
        // 创建a标签
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件名
        link.download = `原価計算書_${this.order_sn}.xlsx`;
        // 模拟点击下载
        document.body.appendChild(link);
        link.click();
        // 清理资源
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }).catch(error => {
        console.error('下载失败:', error);
        this.$message.error('原価計算書下载失败');
      })
    },
    // 扩展信息-设置
    setExtend(item, method, field, value) {
      let datas = {
        order_detail_id: item.id,
        [field]: value,
      }
      this.$api.orderApi[method](datas).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '保存成功',
            type: 'success',
          })
        }
      })
    },
    // 上传图片前的校验
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isSVG = file.type === 'image/svg+xml';
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error('上传图片只能是 JPG/PNG/SVG 格式!');
      }
      return isJPG || isPNG || isSVG;
    },
    // 上传图片
    async httpUpload(file) {
      let data = await this.createClient(file)
      let order_detail_extend_tj = this.detail.order_detail[this.i].order_detail_extend_tj
      order_detail_extend_tj.images = order_detail_extend_tj.images == null ? [] : order_detail_extend_tj.images
      order_detail_extend_tj.images.push(data.data)
      let datas = {
        order_detail_id: order_detail_extend_tj.order_detail_id,
        images: order_detail_extend_tj.images,
      }
      this.$api.orderApi.setExtendImages(datas).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '上传成功',
            type: 'success',
          })
        }
      })
    },
    // 删除图片
    deleteImg(item, index, imgIndex) {
      item.order_detail_extend_tj.images.splice(imgIndex, 1)
      let datas = {
        order_detail_id: item.id,
        images: item.order_detail_extend_tj.images,
      }
      this.$api.orderApi.setExtendImages(datas).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
          })
        }
      })
    },
    // 上传文件成功后的回调
    handleFileSuccess(res, file) {
      if (res.code == 0) {
        this.$message({
          message: '上传成功',
          type: 'success',
        })
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
      console.log(res, file)
    },
    // 同ID商品
    sameIdGoods() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.goods_id == items.goods_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },

    // 同店铺商品
    sameStoreGoods() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.shop_id == items.shop_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 全选
    selectAll() {
      this.checkedAll = !this.checkedAll;
      this.detail.order_detail.forEach((item) => {
        item.checked = this.checkedAll;
      });
      this.$forceUpdate();
    },
    // 是否全选
    handleSelectChange() {
      this.checkedAll = this.detail.order_detail.every((item) => item.checked);
    },
    // 批量修改
    allEdit(data, field, value) {
      if (data.checked) {
        this.detail.order_detail.forEach((item) => {
          if (item.checked) {
            item[field] = value;
          }
        });
      } else {
        data[field] = value;
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.detail {
  min-width: 1910px;
}

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.search {
  display: flex;
  margin-bottom: 20px;
  position: relative;

  .uploadFile {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
  }
}

.orderDetail {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;

  .tabs {
    margin-bottom: 20px;
  }

  .table {
    font-size: 14px;

    ol {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
        align-items: center !important;
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 30px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .isCustomMade {
        padding-top: 5px;

        /deep/.el-input__inner {
          background-color: rgba(255, 255, 0, 1);

        }
      }

      .imgList {
        display: flex;
        flex-wrap: wrap;

        .item {
          position: relative;
          margin: 0px 5px 10px 5px;

          i {
            position: absolute;
            top: -10px;
            right: -10px;
            font-size: 20px;
            color: #B4272D;
            cursor: pointer;
          }
        }

        .el-image {
          width: 60px;
          height: 60px;
          border-radius: 4px;
        }
      }
    }

    .flex05 {
      flex: 0.3;
      position: relative;

      .isZhu {
        position: absolute;
        bottom: 5px;
        left: 5px;
        width: 100px;
        color: #B4272D;
        font-weight: 600;
        cursor: pointer;
        z-index: 99;
      }

      .isTong {
        color: #85ce61;
      }
    }

    .flex2 {
      flex: 2;
    }

    .flex15 {
      flex: 1.5;
    }

    .important {
      background-color: #e0e7f7;
      max-height: 100px;
      overflow-y: hidden;
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
      transition: all 0.3s;
      min-height: 100px;

      .sorting {
        position: relative;

        .claim {
          position: absolute;
          left: -20px;
          top: -30px;

          i {
            color: #B4272D;
            font-size: 20px;
          }
        }

        .contraband {
          position: absolute;
          top: -30px;
          right: -20px;

          img {
            width: 30px;
          }
        }
      }

      &:hover {
        background-color: #fff;
      }

      .template {
        text-align: center;

        .row {
          margin-bottom: 5px;
        }
      }

      .attribute {
        text-align: left;
        width: 100%;
        padding: 3%;
        height: 100%;
        overflow-y: hidden;

        .row {
          width: 100%;
          margin-bottom: 5px;
        }
      }

      .services {
        text-align: left;
      }

      .text {
        display: block;
        height: 100%;
        overflow: auto;
        padding: 5px;

      }

      .el-textarea {
        height: 100%;
      }

      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .pic {
        position: relative;
        display: flex;
      }

      .edit {
        width: 20px;
        height: 20px;
        margin-left: 5px;

        i {
          font-size: 20px;
          color: #2c96e7;
          cursor: pointer;
        }
      }
    }
  }

  .foot {
    display: flex;
    margin-top: 24px;

    .row {
      margin-right: 40px;
      display: flex;
      line-height: 40px;

      .rmb {
        width: 180px;
      }

    }

  }


}
</style>
